import { computed } from 'vue';

import { NEW_CHAT_TOOLTIP } from '@/components/VisionAi/constants';
import { useVisionAiStore } from '@/stores/vision-ai';
import { useVisionAiConversationsStore } from '@/stores/vision-ai-conversations';

export function useNewChatDisabled() {
  const visionAiStore = useVisionAiStore();
  const visionAiConversationsStore = useVisionAiConversationsStore();

  const newChatDisabled = computed(
    () =>
      visionAiStore.canAccessVisionAiButNotConversational ||
      (visionAiConversationsStore.isCurrentConversationEmpty &&
        !visionAiConversationsStore.summariesSelected),
  );

  const newChatTooltip = computed(() => {
    if (visionAiStore.canAccessVisionAiButNotConversational) return NEW_CHAT_TOOLTIP.UPGRADE;
    if (newChatDisabled.value) return NEW_CHAT_TOOLTIP.DISABLED;
    return undefined;
  });

  return { newChatDisabled, newChatTooltip };
}
